// src/pages/Solutions.js
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SolutionsSection from '../../components/SolutionsSection';
import ProductionsSection from '../../components/ProductionsSection';
import ProductModulesSection from '../../components/ProductModulesSection';
import ImpactSection from '../../components/ImpactSection';
import DeploymentSection from '../../components/DeploymentSection';
import ToSuccessStoriesSection from '../../components/ToSuccessStoriesSection';

import TransportforLondon from "../../assets/images/TransportforLondon.png"
import OrdanceSurvey from "../../assets/images/OrdanceSurvey.png"
import DSONationalLaboratories from "../../assets/images/DSONationalLaboratories.png"
import WAVE1 from "../../assets/images/wave1.png"

import TrafficIcon from "../../assets/images/traffic.svg";
import ODIcon from "../../assets/images/od.svg";
import FootfallIcon from "../../assets/images/footfall.svg";
import ParksIcon from "../../assets/images/parks.svg";
import CarbonIcon from "../../assets/images/carbon.svg";
import UrbanIcon from "../../assets/images/urban.svg";

const SpacetimeCityTwin = () => {
    const modules = [
    {
      icon: TrafficIcon,
      title: "Traffic Flow Intelligence",
      desc: "Real-time and historical vehicle flow and speed analysis",
      useCase: "Congestion management | traffic-signal planning"
    },
    {
      icon: ODIcon,
      title: "OD Matrix & Mobility Patterns",
      desc: "Origin–destination mapping across travel modes",
      useCase: "Demand forecasting | transport policy evaluation"
    },
    {
      icon: FootfallIcon,
      title: "Footfall & Activity Analytics",
      desc: "Pedestrian flow around high streets, POIs, and events",
      useCase: "Retail vitality | tourism and safety analytics"
    },
    {
      icon: ParksIcon,
      title: "Parks & Green-Space Dynamics",
      desc: "Use and accessibility of parks and public spaces",
      useCase: "ESG / wellbeing reporting | urban design"
    },
    {
      icon: CarbonIcon,
      title: "Carbon & Environmental Exposure",
      desc: "Emission footprint and air/noise exposure dashboard",
      useCase: "Net-zero monitoring | low-emission zoning"
    },
    {
      icon: UrbanIcon,
      title: "Urban Activity Model (Beta)",
      desc: "Combined behavioural patterns of mobility + environment",
      useCase: "Scenario simulation | strategic foresight"
    }
  ];
    const impacts = [
    {
      value: "+20%",
      label: "Route efficiency",
      source: "TfL Go App pilot"
    },
    {
      value: "-15%",
      label: "Congestion reduction",
      source: "CityTwin simulation tests"
    },
    {
      value: "+25%",
      label: "Footfall prediction accuracy",
      source: "Retail case studies"
    },
    {
      value: "+40%",
      label: "Carbon exposure mapping coverage",
      source: "OS / xRenewable trials"
    }
  ];
    const options = [
    "Cloud-based SaaS (subscription or API licence)",
    "On-premise / hybrid for secure government networks",
    "Custom integrations with GIS, BIM, or transport systems"
  ];
  return (
    <div>
      <Header />
      <SolutionsSection 
        title="Urban Mobility & Sustainability Intelligence"
        subtitle="Turning city data into predictive, actionable insight."/>
      <ProductionsSection
       backgroundImage={WAVE1}
        title="Spacetime CityTwin™"
        descriptions={[
          "Productions™ is a modular digital-twin platform that fuses mobility, environmental, and behavioural data into one dynamic urban intelligence system.",
          "It enables governments, planners, and infrastructure partners to see, simulate, and improve how their cities move, breathe, and evolve."
        ]}
        
        logos={[
          { 
            src: TransportforLondon, 
            alt: "Transport for London", 
            href: "#" 
          },
          { 
            src: DSONationalLaboratories, 
            alt: "DSO National Laboratories", 
            href: "#" 
          },
          { 
            src: OrdanceSurvey, 
            alt: "Ordnance Survey", 
            href: "#" 
          }
        ]}
      />
      <ProductModulesSection modules={modules}/>
      <ImpactSection impacts={impacts}/>
      <DeploymentSection options={options}/>
      <ToSuccessStoriesSection 
        title="See how CityTwin™ can power your city’s next leap in data-driven mobility and sustainability." />
      <Footer/>
    </div>
  );
};

export default SpacetimeCityTwin;
